module.exports = __webpack_public_path__ + "img/dj.c33fb6a3.svg";